import React, { useState, useEffect, useRef } from 'react';
import {CoachesList} from '../styles'

const CoachesListComponent = ({ coaches }) => {
  const coachesContainerRef = useRef(null);
  const nameRefs = useRef([]);
  const [visibleNames, setVisibleNames] = useState(coaches);
  const [coachesHiddenCount, setCoachesHiddenCount] = useState(0);

  useEffect(() => {
    const calculateVisibleNames = () => {
      if (!coachesContainerRef.current || !nameRefs.current.length) return;

      const containerWidth = coachesContainerRef.current.offsetWidth;
      const containerHeight = coachesContainerRef.current.offsetHeight;
      let usedWidth = 0;
      let fitCount = 0;
      let usedHeight = 0;
      let rowCount = 1;

      for (let i = 0; i < coaches.length; i++) {
        const nameEl = nameRefs.current[i];
        if (!nameEl) continue;

        const nameWidth = nameEl.offsetWidth;
        const nameHeight = nameEl.offsetHeight;

        // Move to second row if width overflows
        if (usedWidth + nameWidth > containerWidth) {
          rowCount++;
          usedWidth = 0;
          usedHeight += nameHeight;
        }

        // If exceeding second row, stop adding names
        if (rowCount > 2 || usedHeight + nameHeight > containerHeight) break;

        usedWidth += nameWidth;
        fitCount++;
      }

      if (fitCount < coaches.length) {
        setVisibleNames(coaches.slice(0, fitCount-1));
        setCoachesHiddenCount(coaches.length - (fitCount-1));
      } else {
        setVisibleNames(coaches);
        setCoachesHiddenCount(0);
      }
    };

    calculateVisibleNames();
    window.addEventListener("resize", calculateVisibleNames);

    return () => window.removeEventListener("resize", calculateVisibleNames);
  }, []);
  
    
  return (
    <CoachesList ref={coachesContainerRef} as='div'>
      {visibleNames.map((person, index) => {
        if (index < visibleNames.length - 1) {
          return <span style={{display: 'inline-block'}}  key={index} ref={(el) => (nameRefs.current[index] = el)}>{`${person.firstName} ${person.lastName}, `}</span>
        } else {
          return <span key={index} ref={(el) => (nameRefs.current[index] = el)}>{`${person.firstName} ${person.lastName}`}</span>
        }
      })}
      {coachesHiddenCount > 0 && <span>... +{coachesHiddenCount}</span>}
    </CoachesList>
  )
}
export default CoachesListComponent;